const translations = {
  "en": {
    "Reach Max.": "Reach Max.",
    "Select Portfolio": "Select Portfolio"
  },
  "zh-tw": {
    "Reach Max.": "達到最大值。",
    "Select Portfolio": "選擇投資組合"
  }
};

export default translations;
